'use strict';
import { Helper } from "../helpers/Helper.js";

export class SearchCampaignsProperly {
	#admin_ajax;

	constructor() {
		this.#admin_ajax = admin_ajax[0];
		this.search_input = document.querySelector(
			".products-archive-list-filters input[name=products-archive-list-search]"
		);
		this.sorting_select = document.querySelector(
			".products-archive-list-filters select[name=products-archive-list-sorting]"
		);
		this.results_box = document.querySelector(".products_archive_wrapper");
		this.default_pagination = document.querySelector(".levcharity-basic-pagination");
		this.nothing_found_text = document.querySelector(".products-archive-list-empty");

		if (
			!this.nothing_found_text ||
			!this.sorting_select ||
			!this.search_input ||
			!this.results_box
		) {
			return
		}

		this.available_pages = 0
		this.current_page = 1
		this.pagination_start_from_left = 1
		this.pagination_start_from_right = -3
		if(this.default_pagination){
			this.pagination = this.default_pagination.cloneNode(true)
			this.default_pagination.insertAdjacentElement('afterend', this.pagination)
			this.pagination.style.display = 'none'
			this.default_prev_page_button = this.pagination.querySelector("a.prev")
			this.default_next_page_button = this.pagination.querySelector("a.next")
		}

		this.campaigns_of_current_page = this.results_box.innerHTML
		this.search_input.addEventListener('input', this.#debounce(this.#getCampaigns.bind(this), 1000));
		this.sorting_select.addEventListener('change', this.#getCampaigns.bind(this));

		this.pagination?.querySelector(".prev")?.classList?.remove("disabled")
		this.pagination?.querySelectorAll("a")?.forEach(el => {
			el.addEventListener('click', this.#getCampaigns.bind(this))
			el.removeAttribute("href")
		})
		// this.sorting_select.dispatchEvent(new Event('change', { bubbles: true }))
	}

	async #getCampaigns(e) {
		e.preventDefault();
		if(e.target.dataset?.page || e.target?.value?.trim()){
			//check if page/select/input is selected or changed
			if(e.target.dataset?.page){
				//if page changed
				if(e.target.nextElementSibling.classList.contains('placeholder')){
					//show additional 2 pages when '...' is next page after selected page
					this.pagination_start_from_left += 2
				}
				else if(e.target.previousElementSibling.classList.contains('placeholder')){
					//show additional 2 pages when '...' is previous page before selected page
					this.pagination_start_from_right -= 2
				}
				this.current_page = Number(e.target.dataset?.page)
				this.pagination?.querySelector('a.current[data-page]')?.classList?.remove('current')
				e.target.classList.add('current')
			}else{
				this.current_page = 1
			}
			//activate loading and hide default pagination
			if(this.default_pagination) this.default_pagination.style.display = 'none'
			if(this.pagination) this.pagination.style.display = 'none'
			this.results_box.setAttribute('style', 'display:grid !important')
			this.results_box.classList.add('loading')
			this.nothing_found_text.style.display = 'none'

		}else if(e.target.classList.contains('prev') || e.target.classList.contains('next')){
			//if prev/next buttons selected
			if(this.default_pagination) this.default_pagination.style.display = 'none'
			this.results_box.setAttribute('style', 'display:grid !important')

			//calculate future page
			const future_current_page = this.current_page + (e.target.classList.contains('next') ? 1 : -1)

			//get closest future page by diffs comparison if future page is under '...'
			// optional chainings is here to ensure that when user on page where
			// no placeholder shown(e. g. last 7 pages or first and only seven pages available)
			const left_diff = Math.abs(
				future_current_page - Number(this.pagination?.querySelector('.placeholder')?.previousElementSibling?.dataset?.page ?? 0)
			)
			const right_diff = Math.abs(
				future_current_page - Number(this.pagination?.querySelector('.placeholder')?.nextElementSibling?.dataset?.page ?? 0)
			)

			//check if placeholder near any active pagination button
			const is_placeholder_here = [
				this.pagination?.querySelector('.placeholder')?.previousElementSibling,
				this.pagination?.querySelector('.placeholder')?.nextElementSibling,
			].includes(this.pagination?.querySelector('a.current[data-page]'))

			//check if current pagination button at the start or end of available buttons(not available pages)
			const is_left_edge_achived = e.target.nextElementSibling?.classList?.contains('current')
			const is_right_edge_achived = e.target.previousElementSibling?.classList?.contains('current')

			if(future_current_page == 0 || future_current_page > this.available_pages){
				//if future page exceed available range, do nothing
				return
			}
			else if(left_diff < right_diff && is_placeholder_here){
				//if future page closer to left side pagination buttons, load additional 2 pages
				this.pagination_start_from_left += 2
			}
			else if(right_diff < left_diff && is_placeholder_here){
				//if future page closer to right side pagination buttons, load additional 2 pages
				this.pagination_start_from_right -= 2
			}
			else if(is_left_edge_achived){
				this.pagination_start_from_left -= 2
			}
			else if(is_right_edge_achived){
				this.pagination_start_from_right += 2
			}
			this.results_box.classList.add('loading')
			this.current_page = future_current_page
		}
		else{
			//if everything is same as before(input, select), load default campaigns with it pagination
			this.results_box.innerHTML = this.campaigns_of_current_page
			this.nothing_found_text.style.display = 'none'
			if(this.default_pagination) this.default_pagination.style.display = 'flex'
			if(this.pagination) this.pagination.style.display = 'none'
			return
		}
		await Helper.request(this.#admin_ajax, {
			action: 'search_campaigns_properly',
			nonce: this.search_input.dataset?.nonce,
			product_type: this.results_box.dataset?.productType,
			total_donation: this.results_box.dataset?.totalDonation,
			search_text: this.search_input.value,
			sort_by: this.sorting_select.value,
			data_per_page: this.results_box.dataset?.perPage,
			page: this.current_page,
		}).then(async response => {
			this.results_box.classList.remove('loading')
			if(!response.html_to_paste.length){
				this.results_box.innerHTML = ''
				this.nothing_found_text.style.display = 'block'
				if(this.pagination) this.pagination.style.display = 'none'
				return
			}
			if(response.available_pages>1){
				this.available_pages = response.available_pages
				if(this.pagination) this.pagination.style.display = 'flex'

				let new_pagination_html = ''
				// construct new html
				for (let page_num = 1; page_num <= this.available_pages; page_num++){
					if(page_num >= this.pagination_start_from_left+3 && page_num <= (this.available_pages+this.pagination_start_from_right)){
						if(page_num == this.pagination_start_from_left+4 && this.available_pages>7){
							new_pagination_html += '<a class="pagination-page-number placeholder placeholder-1">…</a>'
						}
					}
					else if((page_num >= this.pagination_start_from_left && page_num <= this.available_pages+this.pagination_start_from_right+3)) {
						new_pagination_html += `
							<a data-page="${page_num}" class="pagination-page-number ${page_num == this.current_page ? 'current' : ''}" href="">
								${page_num}
							</a>
						`
					}
				}

				// change pagination html
				if(this.pagination) this.pagination.innerHTML = this.default_prev_page_button.outerHTML + new_pagination_html + this.default_next_page_button.outerHTML

				// add events again(events before was deleted after changing pagination html)
				this.pagination?.querySelector(".prev")?.classList.remove("disabled")
				this.pagination?.querySelectorAll("a")?.forEach(el => {
					el.addEventListener('click', this.#getCampaigns.bind(this))
					el.removeAttribute("href")
				})
			}
			this.nothing_found_text.style.display = 'none'
			this.results_box.innerHTML = response.html_to_paste.join('')

		})
	}

	#debounce(func, delay) {
		let timer;
		return function (...args) {
			clearTimeout(timer);
			timer = setTimeout(() => {
				func(...args);
			}, delay);
		};
	}
}
